export const CONFIRM_SWITCH_BANNER_CLOSED = "CONFIRM_SWITCH_BANNER_CLOSED";
